// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__2KQN0","error":"Notification_error__2LryW","success":"Notification_success__e9UVn"};